import { styled } from '@mui/material/styles';
import type { ReactNode, SyntheticEvent } from 'react';

const NoLineHeight = styled('span', { name: 'StopPropagationNoLineHeight' })({
  lineHeight: 0,
});

type Event = 'onClick' | 'onMouseDown' | 'onMouseUp';

interface StopPropagationProps {
  children: ReactNode;
  events?: Event[];
}

const StopPropagation = ({
  children,
  events = ['onClick'],
}: StopPropagationProps) => {
  const handlers = events.reduce((acc, event) => {
    acc[event] = (e: SyntheticEvent) => e.stopPropagation();
    return acc;
  }, {} as Record<Event, (e: SyntheticEvent) => void>);

  return <NoLineHeight {...handlers} children={children} />;
};

export default StopPropagation;
